export default __webpack_public_path__ + "static/media/Ability_Persuasion.6df78683.png";